module.exports = __webpack_public_path__ + "media/fonts/dinot/dinotregular-65efdc23bdd4c3d389b80e7923bd5dfe.woff2";